<template>
	<div id="footer">
		<b-container>
			<div class="to-the-top-link-container">
				<a href="#" v-scroll-to="'#app'" title="Back to the top">
					<span class="chevron-up"></span>
					To the top
				</a>
			</div>
			<div class="btn-container">
				<a 	:href="pdfLinks.full"
						class="btn"
						target="_blank">
					Download Full Report 2017 <img src="../assets/img/icons/dl-white.svg" width="17">
				</a>
			</div>
			<p class="main-site-text">
				Main site <br>
				<a href="http://www.ahlstrom-munksjo.com">
					www.ahlstrom-munksjo.com
				</a>
			</p>

			<div class="social-media-container">
				<a href="https://se.linkedin.com/company/ahlstrom-munksj%C3%B6" target="_blank" class="social-media-icon" title="Wisit us at linkedin">
					<img src="../assets/img/icons/linkedin.svg">
				</a>

				<a href="https://twitter.com/AhlstromMunksjo" target="_blank" class="social-media-icon" title="Wisit us at twitter">
					<img src="../assets/img/icons/twitter.svg">
				</a>

				<a href="https://www.instagram.com/ahlstrommunksjo/" target="_blank" class="social-media-icon" title="Wisit us at instagram">
					<img src="../assets/img/icons/instagram.svg">
				</a>
			</div>
			<div class="footer-bottom-text-container">
				<span>&copy; 2018 Ahlstrom-Munksjö</span>
				<b-button  variant="link" class="btn-open-modal" @click="showModal('showTerms')">
				  Ahlstrom-Munksjö site terms
				</b-button>
				<b-button  variant="link" class="btn-open-modal" @click="showModal('showPrivacy')">
				  Privacy policy
				</b-button>
			</div>
		</b-container>
		<b-modal ref="showTerms" hide-footer size="lg" title="Ahlstrom-Munksjö site terms" title-tag="h3">
			<h4>
				Legal Notice
			</h4>
			<p>
				By accessing Ahlstrom-Munksjö’s website you agree to the following site terms. Please read these site terms carefully before using this website. You must not use the Ahlstrom-Munksjö website if you do not agree to all of the following site terms.
			</p>
			<h4>
				Copyrights
			</h4>
			<p>
				The contents of Ahlstrom-Munksjö website are owned by Ahlstrom-Munksjö Oyj and/or its subsidiaries (hereinafter referred to as “Ahlstrom-Munksjö”). The Ahlstrom-Munksjö website is subject to copyright protection, with all copyrights retained by Ahlstrom-Munksjö. All rights are reserved by Ahlstrom-Munksjö. “Ahlstrom-Munksjö”, the Ahlstrom-Munksjö Oyj Signature (logo) and Ahlstrom-Munksjö product names are trademarks or registered trademarks of Ahlstrom-Munksjö.
			</p>
			<p>
				The contents of Ahlstrom-Munksjö website are owned by Ahlstrom-Munksjö Oyj and/or its subsidiaries (hereinafter referred to as “Ahlstrom-Munksjö”). The Ahlstrom-Munksjö website is subject to copyright protection, with all copyrights retained by Ahlstrom-Munksjö. All rights are reserved by Ahlstrom-Munksjö. “Ahlstrom-Munksjö”, the Ahlstrom-Munksjö Oyj Signature (logo) and Ahlstrom-Munksjö product names are trademarks or registered trademarks of Ahlstrom-Munksjö.
			</p>
			<p>
				Reproduction, transfer, distribution or storage of part or all of the contents of this website in any form without the prior written permission of Ahlstrom-Munksjö is prohibited, except that you are allowed to store on your computer or print copies of extracts from this website for your personal use only in accordance with these site terms. The use of press releases and other public information is permitted provided that the source of the information is properly cited.
			</p>
			<h4>
				Disclaimer and Limitation of Liability
			</h4>
			<p>
				The contents of this website are provided on “as is” and “as available” basis and without any express or implied representations or warranties in relation to the completeness, correctness, accuracy, reliability, functionality or authenticity of this website or otherwise. Although Ahlstrom thoroughly reviews all documents published on the website, any Ahlstrom documentation published on the website may include inaccuracies or errors. Ahlstrom reserves the right to revise, update or change this website or withdraw access to it at any time without notice. Ahlstrom does not warrant that this website or the server that makes it available are free of viruses or other harmful components.
			</p>
			<p>
				UNDER NO CIRCUMSTANCES SHALL AHLSTROM BE LIABLE FOR ANY DIRECT, INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL OR OTHER DAMAGES, LOSSES OR EXPENSES WHATSOEVER THAT RESULT FROM THE USE OF, ATTEMPTED USE OF OR THE INABILITY TO USE, THE CONTENTS OF THIS WEBSITE OR RELATED TO YOUR ACCESSING AHLSTROM’S PAGES OR ANY SITE LINKED THERETO OR RELATED TO ANY FAILURE OF PERFORMANCE, ERROR, OMISSION, INTERRUPTION, DEFECT, DELAY IN OPERATION OR TRANSMISSION, COMPUTER VIRUS OR LINE OR SYSTEM FAILURE.
			</p>
			<p>
				AS SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF CERTAIN WARRANTIES OR LIMITATIONS OF LIABILITY, THE LIABILITY OF AHLSTROM WOULD IN SUCH CASE BE LIMITED TO THE GREATEST EXTENT PERMITTED BY LAW.
			</p>
			<h4>
				Submitting of Information or Material
			</h4>
			<p>
				By submitting information or material to this website you agree to the following terms: (i) Such information or material is made available by you with the knowledge that it is non-confidential and non-proprietary and may be published by Ahlstrom-Munksjö; (ii) You represent and warrant that such information or material is fit for publication and does not contain anything that is unlawful or otherwise unfit for publication; (iii) You will make best efforts to scan and remove any viruses or other contaminating or harmful features before submitting any information or material; (iv) You agree to indemnify Ahlstrom-Munksjö if any third party takes action against Ahlstrom-Munksjö in relation to such information or material submitted by you; (v) You own such information or material and/or have unlimited right to submit it to Ahlstrom-Munksjö and Ahlstrom-Munksjö may publish the material and/or incorporate it, or any concepts described in it, in its products or processes without accountability or liability for compensation; and (vi) You agree not to take action against Ahlstrom in relation to such material submitted by you.
			</p>
			<h4>
				External Links
			</h4>
			<p>
				This website may include links to sites on the Internet that are owned or operated by third parties. Ahlstrom-Munksjö has no control over the content of third party sites and does not assume any responsibility for material created or published by such third party sites.
			</p>
		</b-modal>
		<b-modal ref="showPrivacy" hide-footer size="lg" title="Privacy Policy" title-tag="h3">
			<p>
				By accessing Ahlstrom-Munksjö’s website www.ahlstrom-munksjo.com you agree to the terms of the following Privacy Policy. Please read this Privacy Policy carefully before using this website. You must not use the Ahlstrom-Munksjö website if you do not agree to all of the terms of the following Privacy Policy.
			</p>
			<p>
				This Privacy Policy has been posted and is effective as of April 3, 2017.
			</p>
			<p>
				This Privacy Policy describes the information Ahlstrom-Munksjö collects about you and the measures Ahlstrom-Munksjö takes to help ensure the security of information collected through the Ahlstrom-Munksjö website.
			</p>
			<h4>
				Data Controller
			</h4>
			<address>
				Ahlstrom-Munksjö<br>
				Box 70365 <br>
				107 24 Stockholm <br>
				Sweden
				<br>
				<br>
				Tel: <a href="tel:+46102501000">+46 (0)10 250 10 00</a>
				<br>
				Fax: +46 (0)8 20 21 51 <br>
			</address>
			<h4>
				Non-personal Information
			</h4>
			<p>
				All activity on the Ahlstrom-Munksjö website is logged and your IP address is stored to the log. The purpose of the log is to collect information on service usage volumes and patterns, number of visitors, the parts of the website that have/have not been accessed or used, and system errors. The collected non-personal information is used to further develop and enhance the Ahlstrom-Munksjö website. The log does not collect personal information such as name, address, date of birth, e-mail addresses, phone numbers, job titles, etc. (hereinafter referred to as “Personal Information”).
			</p>
			<h4>
				Personal Information
			</h4>
			<p>
				Ahlstrom collects only the Personal Information that you voluntarily submit through the Ahlstrom-Munksjö website. This may include information such as your name, address and/or e-mail address. Ahlstrom-Munksjö does not collect Personal Information without your knowledge.
			</p>
			<h4>
				Use of Personal Information
			</h4>
			<p>
				Unless otherwise stated in separate privacy statements on this website or unless Ahlstrom-Munksjö specifically informs you otherwise before you submit Personal Information, Ahlstrom-Munksjö will collect and process Personal Information only (i) to respond to your inquiries or comments, (ii) for the marketing and selling of Ahlstrom-Munksjö’s products and services, (iii) to better understand your viewing patterns and needs, and (iv) for the personalization of the website content and user experience.
			</p>
			<h4>
				Sharing Your Personal Information with Others
			</h4>
			<p>
				In order to carry out the above and subject to requirements of applicable laws, Personal Information may be transferred between Ahlstrom-Munksjö group companies or third party service providers in countries where the level of protection does not necessarily meet the EU legal requirements. The recipient of such information shall be required to protect the confidentiality and security of the Personal Information it receives and it may not use it for any purpose other than the agreed purpose. Further, due to the technical and practical requirements of the processing, some of the Personal Information may be stored on the servers of subcontractors or processed by subcontractors who have agreed to the data processing standards of Ahlstrom-Munksjö.
			</p>
			<p>
				Ahlstrom-Munksjö's strict policy is not to lease or sell Personal Information to third parties.
			</p>
			<h4>
				Cookies
			</h4>
			<p>
				To improve your visits to the Ahlstrom-Munksjö website, Ahlstrom-Munksjö may use “cookies” to obtain non-personal information. Cookies are text information files that your browser places on your computer when you visit a website. Ahlstrom-Munksjö may collect this data to analyze the viewing patterns of our site visitors, but no Personal Information will be collected.
			</p>
			<p>
				If you want to be notified when cookies are placed on your computer, or you do not wish to receive them, please check whether your web browser supports such functions. Please note that if you do not allow the use of cookies, you may not be able to view all parts of this website.
			</p>
			<h4>
				External Links and Third Parties
			</h4>
			<p>
				The Ahlstrom-Munksjö website contains links to other sites operated by third parties such as social media sites. Ahlstrom-Munksjö is not responsible for the privacy practices or the content of such other sites. Please refer to the privacy statements of such third party sites.
			</p>
			<h4>
				Contacting Ahlstrom-Munksjö
			</h4>
			<p>
				You may at any time contact Ahlstrom-Munksjö at the address below to check that the Personal Information related to you is accurate or to request your Personal Information to be deleted. Ahlstrom will at your request rectify or erase your Personal Information. Further, you shall always have the right to object the processing of your Personal Data for direct marketing purposes. Please note that in order for Ahlstrom-Munksjö to execute your request you may be required to verify your identity.
			</p>
			<p>
				As Ahlstrom-Munksjö continuously seeks to develop its website, this Privacy Policy also may be updated time to time to correspond with the applicable laws and Ahlstrom-Munksjö policies. Thus, Ahlstrom-Munksjö reserves the right to amend this Privacy Policy.
			</p>
			<p>
				For possible questions, comments and requests related to this Privacy Policy and/or Personal Information, please contact Ahlstrom-Munksjö by sending an e-mail to <a href="mailto:communication@ahlstrom-munksjo.com">communication@ahlstrom-munksjo.com</a>.
			</p>
		</b-modal>
	</div>
</template>
<script>
	import full from '../assets/pdf/full-report.pdf';

	export default {
		data() {
      return {
        pdfLinks: {
          'full': full
        }
      }
    },
		methods: {
      showModal(modal) {
        this.$refs[modal].show();
      }
    }
	}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue